import { useGetUserQuery } from '@/api/piloteer';
import { useGetCompanyLocalizationQuery } from '@/api/piloteer/localization';
import { useAppSelector } from '@/store/hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Syncs the i18n locale with the company's configured ui_language.
 * Uses the dedicated localization endpoint rather than the nested user.company object
 * (which does not include the localization field from GET /users).
 */
export const useLocaleSync = () => {
  const { i18n } = useTranslation();
  const session = useAppSelector((state) => state.auth.session);

  const { data: user } = useGetUserQuery(undefined, { skip: !session });

  const companyUuid = user?.company?.uuid;

  const { data: localization } = useGetCompanyLocalizationQuery(
    companyUuid ?? '',
    { skip: !companyUuid }
  );

  useEffect(() => {
    const target = localization?.uiLanguage ?? 'en';
    if (i18n.language !== target) {
      i18n.changeLanguage(target);
    }
  }, [localization?.uiLanguage, i18n]);
};
